import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import InvTabBar from '../../components/InvTabBar';
import InvButton from '../../components/InvButton';
import StockAdjustmentListPanel from '../../components/stock/StockAdjustmentListPanel';
import ChangeBinPanel from '../../components/stock/ChangeBinPanel';
import SplitBatchPanel from '../../components/stock/SplitBatchPanel';
import { STOCK_ADJUSTMENT_HUB_TABS } from '../../constants/storeManagement';

export default function StockAdjustmentHub() {
  const history = useHistory();
  const { url } = useRouteMatch();
  const [activeTab, setActiveTab] = useState('adjustments');
  const stockBase = url.replace(/\/adjustments\/?$/, '');

  return (
    <Box>
      <PageHeader
        eyebrow="Inventory Management · Stock"
        title="Stock Adjustments"
        description="Correct on-hand qty (draft → authorize), change bin location, or split batches"
        actions={(
          <InvButton variant="outlined" size="small" onClick={() => history.push(stockBase || `${url}/..`)}>
            Back to Stock
          </InvButton>
        )}
      />

      <InvTabBar
        tabs={STOCK_ADJUSTMENT_HUB_TABS}
        activeTab={activeTab}
        onChange={setActiveTab}
        ariaLabel="Stock adjustment sections"
      />

      {activeTab === 'adjustments' && <StockAdjustmentListPanel />}
      {activeTab === 'change-bin' && <ChangeBinPanel />}
      {activeTab === 'split-batch' && <SplitBatchPanel />}
    </Box>
  );
}
